import ReactDOM from "react-dom";

const TemplateButtonsPortal = ({ children }) => {
  const el = document.getElementById("template_buttons");
  if (el) {
    return ReactDOM.createPortal(children, el);
  } else {
    return null;
  }
  return ReactDOM.createPortal(children, el);
};

export default TemplateButtonsPortal;
